import React, { Fragment, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Editor from './Editor';
import Answers from './Answers.tsx';
import {
  Header,
  PageFooter,
  PageHeader,
  SharedConfigContext,
  MainPage,
  SiteConfig,
  NotFoundPage,
  FailPage,
} from '@bepro-travel/fe.shared';
import { sharedConfig } from '../constant.tsx';
import BookPage from './BookPage.tsx';
import SuccessPage from './SuccessPage.tsx';
import PaymentPage from './PaymentPage.tsx';
import MainPageContent from './MainPage.tsx';
import { MainContext } from '../context/MainContext.ts';
import { useGetPage } from '../hooks/useGetPage.ts';
import Footer from './Footer.tsx';
import PackagesPage from './PackagesPage.tsx';

const MainRtlPage = () => {
  return (
    <div className="rtl">
      <MainPage skipRecaptcha={true} />
    </div>
  );
};

const MainFailPage = () => {
  useGetPage('');
  return (
    <div>
      <FailPage />
    </div>
  );
};

const AssistantPage = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const header = document.querySelector('.header');
    if (header) {
      if (
        sessionStorage.getItem('alpToken') &&
        !pathname.toLowerCase().includes('payment')
      ) {
        header.classList.add('header-img');
      } else {
        header.classList.remove('header-img');
      }
    }
  }, [pathname]);

  return <Fragment />;
};

const Router = () => {
  const [header, setHeader] = useState<PageHeader | undefined>();
  const [footer, setFooter] = useState<PageFooter | undefined>();
  const [siteConfig, setSiteConfig] = useState<SiteConfig | undefined>(
    undefined
  );

  const sharedC = {
    ...sharedConfig,
    setHeader,
    setFooter,
    setSiteConfig,
    header,
    footer,
    siteConfig,
    hotelConfig: {},
    setHotelConfig: () => {},
    defaultUserSiteConfig: {},
    userSiteConfig: {},
    setUserSiteConfig: () => {},
    proposal: {
      flights: [],
      hotels: [],
      dynamic: [],
      ilPackages: [],
      transfers: [],
    },
    setProposal: () => {},
  };

  return (
    <MainContext.Provider
      value={{ setHeader, header, setFooter, setSiteConfig }}
    >
      <SharedConfigContext.Provider value={sharedC}>
        <BrowserRouter>
          <Header />
          <AssistantPage />
          <Routes>
            <Route path="/" Component={MainPageContent} />
            <Route path="/home" Component={MainPageContent} />
            <Route path="/packages" Component={PackagesPage} />
            <Route path="/home/packages" Component={PackagesPage} />
            <Route path="/formeditor" Component={Editor} />
            <Route path="/pages/*" Component={MainRtlPage} />
            <Route path="*" Component={MainRtlPage} />
            <Route path="/fill-visa-details" Component={Answers} />
            <Route path="book" Component={BookPage} />
            <Route path="success" Component={SuccessPage} />
            <Route path="payment" Component={PaymentPage} />
            <Route path="fail" Component={MainFailPage} />
            <Route path="*" Component={NotFoundPage} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </SharedConfigContext.Provider>
    </MainContext.Provider>
  );
};

export default Router;
